module.exports = __webpack_public_path__ + "AnirudhBhandari-be2d7c12.webp";